// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3ExJy","right":"styles_right__3Oxgm"};